import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root'
})
export class IsSelfOrIsAdminGuard implements CanActivate {

    constructor(private readonly router: Router, private readonly authService: AuthService) {}

    public canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot):
        Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const currentUser = this.authService.currentUserValue;
        if (currentUser && currentUser.isAdmin) {
            return true;
        }

        // Read the user ID out of the request path
        const userId = +next.paramMap.get('id');
        if (userId && userId === currentUser.id) {
            return true;
        }

        this.router.navigate(['/403']);
        return false;
    }
}
